'use client';

import { Toaster as SonnerToaster, toast, type ToasterProps } from 'sonner';

/**
 * shadcn-styled Toaster wrapper around sonner. Mount once at the app root;
 * call `toast(...)` from anywhere to surface a toast.
 *
 * The theme is not inferred here — callers can pass `theme="dark"` /
 * `"light"` if they need it to follow a ThemeProvider, otherwise sonner
 * inherits the CSS variables from the surrounding theme and renders in
 * the user's OS preference.
 */
export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { toast };
